<h2>EDIZIONE 2020</h2>
	<div id="istruzioni">
		<h3>Istruzioni</h3>
		<ul>
			<li>Le Cryptowars2020 si svolgono dal 25 al 31 Ottobre 2020.</li>
			<li>Inizio iscrizione dei team: 19 Ottobre 2020.</li>
			<li>Fine iscrizione dei team: 24 Ottobre 2020.</li>
			<li>Inizio gara: 25 Ottobre 2020 ore 14:00 (Milano).</li>
			<li>Fine gara: 31 Ottobre 2020 ore 23:59 (Milano).</li>
			<li>Sono ammessi alla gara team composti da un massimo di 5 studenti. Con "studenti" 
				intendiamo iscritti a: laurea, laurea triennale, laurea magistrale e neolaureati 
				(nel 2020).</li>
			<li>Il team partecipante deve essere identificato con un unico indirizzo e-mail. Per 
				iscriversi bisogna inviare una email a cryptowarsdecifris2020&#64;gmail.com, avente come 
				oggetto la parola ISCRIZIONE. Nel messaggio di posta elettronica devono comparire 
				il nome dei partecipanti, l'Universita' di provenienza dei singoli, il nome del team 
				e l'indirizzo e-mail di riferimento.</li>
			<li>Dal 25 al 31 Ottobre, i partecipanti alle CRYPTOWARS possono inviare al più TRE 
				soluzioni al medesimo quesito. Viene tenuta in considerazione solo l'ultima e-mail ricevuta.</li>
			<li>Le soluzioni devono essere inviate allo stesso indirizzo usato per l'iscrizione 
				nel formato specificato nel file della challenge. Solitamente in formato .TXT.</li>
			<li>Ad ogni domanda è associato 1 punto. I vari team acquisiscono punti in maniera 
				incrementale risolvendo le sfide e inviando le risposte corrette. Se alla fine della 
				gara piu' team hanno ottenuto lo stesso punteggio, controllando data e ora dell'ULTIMA 
				soluzione consegnata via email, viene dichiarato vincitore chi ha svolto le sfide nel 
				minor tempo.</li>
			<li>Gli sponsor della gara crittografica, attraverso la De Cifris, mettono a disposizione 
				un premio di 10k Euro che viene così assegnato: 6k Euro al team che si classificherà
				al primo posto, 3k Euro al secondo classificato e infine 1k Euro al terzo.</li>
			<!--<li>Di seguito il <a href="../../../../assets/attivita/cryptowars/
				Cryptowars2020.zip">materiale</a> per la gara. Nel 2020 abbiamo posto quesiti
				di varia natura, i quali spaziavano dalla rottura di alcune chiavi RSA e AES 
				ad alcuni cifrari pensati ad hoc.</li>-->
		</ul>
	</div>
	<div id="FAQ">
		<h3>FAQ</h3>
			<ul>
				<li><i>Devo personalmente implementare del codice per risolvere i quesiti? </i><br>
					Non è richiesto di inviare il codice usato, quindi una via semplice è quella di 
					cercare del codice già implementato. Resta il fatto che, siccome la gara ha soprattutto 
					lo scopo di portare alla comprensione profonda di problemi crittografici, si consiglia 
					di lavorare in maniera autonoma al proprio codice e alla sua ottimizzazione.<br>
				</li>
				<li><i>Devo pensare e implementare nuovi attacchi?</i><br>
					Non necessariamente. Esistono molti attacchi noti in letteratura, quindi cercane uno che 
					ti sembra semplice da capire, implementalo e mandalo in esecuzione!</li>
			</ul>
	</div>
	<div id="news">
		<h3>News</h3>
		<ul>
		<li>[02/10/2020] Annuncio delle Cryptowars 2020. Buon divertimento!!	</li>
		<li>[25/10/2020] I team iscritti alla competizione sono 17 e provengono da: Padova, Perugia, Torino, Milano, Cagliari, Trento, Ancona, Bologna, Venezia, Roma e Pisa.	</li>
		<li>[25/10/2020] Oggi, alle ore 14, daremo il via alla competizione.</li>
		<li>[25/10/2020] Gara iniziata. In bocca al lupo! </li>
		<li>[31/10/2020] Ore 23:59, abbiamo chiuso la competizione.</li>
		<li>[04/11/2020] Ecco la classifica finale delle cryptowars 2020:
			<ol>
				<li>Bartimeus</li>
				<li>pwnthem0le</li>
				<li>Keep Calm and Brute Force (a pari merito con EC Milan, Dalla parte di Eve, CryptoTeamUNITN)</li>
				<li>Etruscan Crypto Cadets</li>
				<li>Flying Pwnycorn, Critto Tanto</li>
				<li>adhfje3*q</li>
				<li>CeSeNA_Ulisse</li>
				<li>I trentastici 4</li>
			</ol>
		</ul>
		<p>
			Complimenti a tutti i partecipanti!
		</p>
	</div>
	<div id="premiazioni">
		<h3>Premiazioni</h3>
		<p>
			La premiazione dei terzi classificati è avvenuta in data 20 maggio 2021, durante la presentazione
			del seminario <i>"Strumenti per fare crittoanalisi nei grafi di isogenie supersingolari"</i>.
			La premiazione dei secondi e primi classificati avverrà durante il <a href="
			https://sites.google.com/view/crittografiaecodici/convegno-annuale">convegno annuale</a>, 
			in data 22 settembre 2021.
		</p>
	</div>